"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.fluidCalculationInputs = fluidCalculationInputs;
exports.batchedFluidCooling = batchedFluidCooling;
exports.batchedFluidHeating = batchedFluidHeating;
exports.batchedDx = batchedDx;
exports.batchedCondenser = batchedCondenser;
exports.batchedSteam = batchedSteam;
const GraphQlRequest = __importStar(require("@genesys/graphql-request"));
const Queries = __importStar(require("./queries"));
/**
 * Geometry in, the operating points a supplier should be asked to run out - one result per coil,
 * so a whole series is prepared in a single call.
 *
 * Unlike the coefficient fits either side of it this is synchronous and returns its data: there is
 * no job to wait for and nothing to email, and the caller needs the rows to build the sheet.
 */
async function fluidCalculationInputs(input, graphqlEndpoint, authorization) {
    const result = await GraphQlRequest.request(Queries.fluidCalculationInputsQuery, { input: input }, false, graphqlEndpoint, authorization);
    return result.user.coilProFluidCalculationInputs;
}
async function batchedFluidCooling(rows, graphqlEndpoint, authorization) {
    const result = await GraphQlRequest.request(Queries.batchedFluidCoolingQuery, {
        input: rows.map(p => p.input)
    }, false, graphqlEndpoint, authorization);
    return result.user.batchedCoilProFluidCoolingCoefficients;
}
async function batchedFluidHeating(rows, graphqlEndpoint, authorization) {
    const result = await GraphQlRequest.request(Queries.batchedFluidHeatingQuery, {
        input: rows.map(p => p.input)
    }, false, graphqlEndpoint, authorization);
    return result.user.batchedCoilProFluidHeatingCoefficients;
}
async function batchedDx(rows, graphqlEndpoint, authorization) {
    const result = await GraphQlRequest.request(Queries.batchedDxQuery, {
        input: rows.map(p => p.input)
    }, false, graphqlEndpoint, authorization);
    return result.user.batchedCoilProDxCoefficients;
}
async function batchedCondenser(rows, graphqlEndpoint, authorization) {
    const result = await GraphQlRequest.request(Queries.batchedCondenserQuery, {
        input: rows.map(p => p.input)
    }, false, graphqlEndpoint, authorization);
    return result.user.batchedCoilProCondenserCoefficients;
}
async function batchedSteam(rows, graphqlEndpoint, authorization) {
    const result = await GraphQlRequest.request(Queries.batchedSteamQuery, {
        input: rows.map(p => p.input)
    }, false, graphqlEndpoint, authorization);
    return result.user.batchedCoilProSteamCoefficients;
}
//# sourceMappingURL=calculate.js.map